import { render, staticRenderFns } from "./ClientesImpagadosPorCanal.vue?vue&type=template&id=5ab24712&scoped=true&"
import script from "./ClientesImpagadosPorCanal.vue?vue&type=script&lang=js&"
export * from "./ClientesImpagadosPorCanal.vue?vue&type=script&lang=js&"
import style0 from "./ClientesImpagadosPorCanal.vue?vue&type=style&index=0&id=5ab24712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab24712",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VChip,VDataIterator,VDivider,VIcon,VList,VListItem,VListItemAction,VListItemContent,VSpacer,VSubheader,VTextField})
